/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Explore_TitleInputs */

const en_us2_search_explore_title = /** @type {(inputs: Search_Explore_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore exercises`)
};

const pt_br2_search_explore_title = /** @type {(inputs: Search_Explore_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar exercícios`)
};

const es_419_search_explore_title = /** @type {(inputs: Search_Explore_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar ejercicios`)
};

const pt_pt2_search_explore_title = /** @type {(inputs: Search_Explore_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar exercícios`)
};

const fr_fr2_search_explore_title = /** @type {(inputs: Search_Explore_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorer les exercices`)
};

const de_de2_search_explore_title = /** @type {(inputs: Search_Explore_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übungen entdecken`)
};

const it_it2_search_explore_title = /** @type {(inputs: Search_Explore_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esplora gli esercizi`)
};

/**
* | output |
* | --- |
* | "Explore exercises" |
*
* @param {Search_Explore_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_explore_title = /** @type {((inputs?: Search_Explore_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Explore_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_explore_title(inputs)
	if (locale === "es-419") return es_419_search_explore_title(inputs)
	if (locale === "pt-PT") return pt_pt2_search_explore_title(inputs)
	if (locale === "fr-FR") return fr_fr2_search_explore_title(inputs)
	if (locale === "de-DE") return de_de2_search_explore_title(inputs)
	if (locale === "it-IT") return it_it2_search_explore_title(inputs)
	return en_us2_search_explore_title(inputs)
});
export { search_explore_title as "search.explore_title" }